import Vue from "vue";

export const SalesPipelineState = {
  stages: [], // { ..., prospect_stages, number_of_prospect}[]
  prospectStage: null,
  prospectInformation: null,
  prospects: [],
  totalProspects: 0,
  prospectInstructionHistories: [],
  prospectActivityHistories: []
};

export const SalesPipelineGetters = {
  stages: state => {
    return state.stages;
  },
  prospectStage: state => {
    return state.prospectStage;
  },
  prospectInformation: state => {
    return state.prospectInformation;
  },
  prospects: state => {
    return state.prospects;
  },
  totalProspects: state => {
    return state.totalProspects;
  },
  prospectInstructionHistories: state => {
    return state.prospectInstructionHistories;
  },
  prospectActivityHistories: state => {
    return state.prospectActivityHistories;
  }
};

export const SalesPipelineMutations = {
  setStage: (state, data) => {
    if (data) {
      const index = state.stages.findIndex(
        i => Number(i.id) === Number(data.id)
      );
      if (index > -1) {
        const arr = [...state.stages];
        arr[index] = {
          ...data,
          prospect_stages: arr[index].prospect_stages || [],
          number_of_prospect: arr[index].number_of_prospect || 0
        };
        Vue.set(state, "stages", arr);
      }
    }
  },
  setStages: (state, data) => {
    const arr = data.map(i => {
      const documents = i.documents.map(d => ({
        ...d,
        documents: d.documents || []
      }));
      return {
        ...i,
        documents,
        prospect_stages: [],
        number_of_prospect: 0
      };
    });
    Vue.set(state, "stages", arr);
  },
  removeStage: (state, data) => {
    const arr = state.stages.filter(i => Number(i.id) !== Number(data.id));
    Vue.set(state, "stages", arr);
  },
  //
  addDocumentStage: (state, data) => {
    const item = { ...data, documents: data.documents || [] };
    const index = state.stages.findIndex(
      i => Number(i.id) === Number(item.instructionable_id)
    );
    if (index > -1) {
      const arr = [...state.stages];
      arr[index].documents = [item, ...arr[index].documents];
      Vue.set(state, "stages", arr);
    }
  },
  setDocumentStage: (state, data) => {
    const item = { ...data, documents: data.documents || [] };
    const index = state.stages.findIndex(
      i => Number(i.id) === Number(item.instructionable_id)
    );
    if (index > -1) {
      const arr = [...state.stages];
      const idx = arr[index].documents.findIndex(
        i => Number(i.id) === Number(item.id)
      );
      if (idx > -1) {
        const docs = [...arr[index].documents];
        docs[idx] = item;
        arr[index].documents = docs;
      }
      Vue.set(state, "stages", arr);
    }
  },
  removeDocumentStage: (state, data) => {
    const index = state.stages.findIndex(
      i => Number(i.id) === Number(data.instructionable_id)
    );
    if (index > -1) {
      const arr = [...state.stages];
      const docs = arr[index].documents.filter(
        i => Number(i.id) !== Number(data.id)
      );
      arr[index].documents = docs;
      Vue.set(state, "stages", arr);
    }
  },
  //
  setProspectStage: (state, data) => {
    if (data) {
      const instructions = data.instructions.map(i => ({
        ...i,
        documents: i.documents || []
      }));
      const prospectStage = { ...data, instructions };

      const index = state.stages.findIndex(
        i => Number(i.id) === Number(prospectStage.stage_id)
      );
      if (index > -1) {
        const arr = [...state.stages];
        const idx = arr[index].prospect_stages.findIndex(
          i => Number(i.id) === Number(prospectStage.id)
        );
        if (idx > -1) {
          const prospectStages = [...arr[index].prospect_stages];
          prospectStages[idx] = prospectStage;
          arr[index].prospect_stages = prospectStages;
        }
        Vue.set(state, "stages", arr);
      }

      Vue.set(state, "prospectStage", prospectStage);
    } else {
      Vue.set(state, "prospectStage", data);
    }
  },
  setProspectStages: (state, data) => {
    const index = state.stages.findIndex(
      i => Number(i.id) === Number(data.stage_id)
    );
    if (index > -1) {
      const arr = [...state.stages];
      arr[index].prospect_stages = data.prospect_stages;
      arr[index].number_of_prospect = data.total_count;
      Vue.set(state, "stages", arr);
    }
  },
  //
  setProspectInformation: (state, data) => {
    Vue.set(state, "prospectInformation", data);
  },
  setProspects: (state, data) => {
    Vue.set(state, "prospects", data.prospects);
    Vue.set(state, "totalProspects", data.total_count);
  },
  setProspectInstructionHistories: (state, data) => {
    const arr = data.map(i => {
      const documents = i.documents || [];
      return { ...i, documents };
    });
    Vue.set(state, "prospectInstructionHistories", arr);
  },
  setProspectActivityHistories: (state, data) => {
    Vue.set(state, "prospectActivityHistories", data);
  }
};

export const SalesPipelineActions = {
  getStages: ({ state, commit, dispatch }, data = {}) => {
    if (!state.currentCenter.enable_sales_pipeline) {
      commit("setStages", []);
      return { success: false, data: [] };
    }
    return Vue.axios.secured
      .get(`/api/v1/stages`)
      .then(response => {
        commit("setStages", response.data);
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to fetch stages from server.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: [] };
      });
  },
  getStage: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .get(`/api/v1/stages/${data.id}`)
      .then(response => {
        commit("setStage", response.data);
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to fetch stage from server.";
        dispatch("showToast", { message, type: "error" });
      });
  },
  createStage: ({ dispatch }, data = {}) => {
    return Vue.axios.secured
      .post("/api/v1/stages", { stage: data.stage })
      .then(response => {
        const title = `New stage added`;
        const message = `Success! New stage has been added.`;
        dispatch("showToast", { title, message, type: "success" });
        // reset all stage
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to create stage.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  updateStage: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .patch(`/api/v1/stages/${data.id}`, { stage: data.stage })
      .then(async response => {
        commit("setStage", response.data);
        await dispatch("getStageProspectStages", { id: data.id });
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to update stage.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  moveProspectStages: ({ dispatch }, data = {}) => {
    return Vue.axios.secured
      .post(`/api/v1/stages/${data.id}/move_prospects`, {
        stage_id: data.stage_id, // destination stage id
        discontinuation_reason: data.discontinuation_reason,
        other_discontinuation_reason: data.other_discontinuation_reason
      })
      .then(response => {
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to move prospect stages.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  deleteStage: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .delete(`/api/v1/stages/${data.id}`)
      .then(response => {
        commit("removeStage", data);
        const title = `Stage deleted`;
        const message = `Success! Stage <b>${data.stage_name}</b> has been deleted.`;
        dispatch("showToast", { title, message, type: "success" });
        return { success: true };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to delete stage.";
        dispatch("showToast", { message, type: "error" });
        return { success: false };
      });
  },
  //
  getInstruction: ({ dispatch }, data = {}) => {
    return Vue.axios.secured
      .get(`/api/v1/instructions/${data.id}`)
      .then(response => {
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to fetch instruction from server.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  createInstruction: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .post("/api/v1/instructions", data)
      .then(async response => {
        if (response.data.instructionable_type === "Stage") {
          commit("addDocumentStage", response.data);
        }
        if (response.data.instructionable_type === "ProspectStage") {
          const input = { id: response.data.instructionable_id };
          await dispatch("getProspectStage", input);
          dispatch("checkCurrentUser");
        }
        const title = `New instruction added`;
        const message = `Success! An instruction has been added.`;
        dispatch("showToast", { title, message, type: "success" });
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to create instruction.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  updateInstruction: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .patch(`/api/v1/instructions/${data.id}`, {
        instruction: data.instruction
      })
      .then(async response => {
        if (response.data.instructionable_type === "Stage") {
          commit("setDocumentStage", response.data);
        }
        if (response.data.instructionable_type === "ProspectStage") {
          const input = { id: response.data.instructionable_id };
          await dispatch("getProspectStage", input);
          dispatch("checkCurrentUser");
        }
        const title = `Instruction updated`;
        const message = `Success! The instruction has been updated.`;
        dispatch("showToast", { title, message, type: "success" });
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to update instruction.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  /* { id, instructionable_id, instructionable_type } */
  deleteInstruction: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .delete(`/api/v1/instructions/${data.id}`)
      .then(async response => {
        if (data.instructionable_type === "Stage") {
          commit("removeDocumentStage", data);
        }
        if (data.instructionable_type === "ProspectStage") {
          const input = { id: data.instructionable_id };
          await dispatch("getProspectStage", input);
          dispatch("checkCurrentUser");
        }
        const title = `Instruction deleted`;
        const message = `Success! The instruction has been deleted.`;
        dispatch("showToast", { title, message, type: "success" });
        return { success: true };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to delete instruction.";
        dispatch("showToast", { message, type: "error" });
        return { success: false };
      });
  },
  //
  /* { id, file: { documents } } */
  uploadDocumentInstruction: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .post(`/api/v1/instructions/${data.id}/add_documents`, data.file)
      .then(async response => {
        if (response.data.instructionable_type === "Stage") {
          commit("setDocumentStage", response.data);
        }
        if (response.data.instructionable_type === "ProspectStage") {
          const input = { id: response.data.instructionable_id };
          await dispatch("getProspectStage", input);
        }
        const title = `New document uploaded`;
        const message = `Success! A document has been added.`;
        dispatch("showToast", { title, message, type: "success" });
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to upload document.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  /* { id, file_id } */
  deleteDocumentInstruction: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .delete(`/api/v1/instructions/${data.id}/delete_document/${data.file_id}`)
      .then(async response => {
        if (response.data.instructionable_type === "Stage") {
          commit("setDocumentStage", response.data);
        }
        if (response.data.instructionable_type === "ProspectStage") {
          const input = { id: response.data.instructionable_id };
          await dispatch("getProspectStage", input);
        }
        const title = `Document deleted`;
        const message = `Success! The document has been deleted.`;
        dispatch("showToast", { title, message, type: "success" });
        return { success: true };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to delete document.";
        dispatch("showToast", { message, type: "error" });
        return { success: false };
      });
  },
  //
  /* KANBAN */
  getStageProspectStages: ({ commit, dispatch }, data = {}) => {
    const params = data.params || "";
    return Vue.axios.secured
      .get(`/api/v1/stages/${data.id}/prospect_stages${params}`)
      .then(response => {
        const payload = {
          stage_id: data.id,
          prospect_stages: response.data.prospect_stages,
          total_count: response.data.total_count
        };
        commit("setProspectStages", payload);
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to fetch prospect stages from server.";
        dispatch("showToast", { message, type: "error" });
        const data = { prospect_stages: [], total_count: 0 };
        return { success: false, data };
      });
  },
  /* LIST */
  getProspectStages: ({ commit, dispatch }, data = {}) => {
    const params = data.params || "";
    return Vue.axios.secured
      .get(`/api/v1/prospect_stages${params}`)
      .then(response => {
        commit("setProspects", response.data);
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to fetch prospects from server.";
        dispatch("showToast", { message, type: "error" });
      });
  },
  getProspectStage: ({ commit, dispatch }, data = {}) => {
    if (!data.id) {
      commit("setProspectStage", null);
      return { success: true, data: null };
    }
    return Vue.axios.secured
      .get(`/api/v1/prospect_stages/${data.id}`)
      .then(response => {
        commit("setProspectStage", response.data);
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to fetch prospect stage from server.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  //
  getProspect: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .get(`/api/v1/prospects/${data.id}`)
      .then(response => {
        commit("setProspectInformation", response.data);
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to fetch prospect from server.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  getProspectInstructionHistories: ({ commit, dispatch }, data = {}) => {
    const params = data.params || "";
    return Vue.axios.secured
      .get(`/api/v1/prospects/${data.id}/instruction_history${params}`)
      .then(response => {
        commit("setProspectInstructionHistories", response.data);
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message =
          err || "Unable to fetch prospect instruction histories from server.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  getProspectActivityHistories: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .get(`/api/v1/prospects/${data.id}/activity_history`)
      .then(response => {
        commit("setProspectActivityHistories", response.data);
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message =
          err || "Unable to fetch prospect activity histories from server.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  createProspect: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .post("/api/v1/prospects", { prospect: data.prospect })
      .then(response => {
        const title = `New prospect added`;
        const message = `Success! New prospect has been added.`;
        dispatch("showToast", { title, message, type: "success" });
        // re-fetch prospect stages
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to create prospect.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  updateProspect: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .patch(`/api/v1/prospects/${data.id}`, { prospect: data.prospect })
      .then(response => {
        commit("setProspectInformation", response.data);
        const title = `Prospect updated`;
        const message = `Success! The prospect has been updated.`;
        dispatch("showToast", { title, message, type: "success" });
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to update prospect.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  moveProspect: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .post(`/api/v1/prospects/${data.id}/move`, {
        stage_id: data.stage_id,
        discontinuation_reason: data.discontinuation_reason,
        other_discontinuation_reason: data.other_discontinuation_reason,
        document_ids: data.document_ids,
        branch_ids: data.branch_ids
      })
      .then(response => {
        const title = `Stage updated`;
        const message = `Success! <b>${data.prospect_name}</b> has been moved to <b>${data.stage_name}</b>.`;
        dispatch("showToast", { title, message, type: "success" });
        dispatch("checkCurrentUser");
        // re-fetch prospect stages
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to create prospect.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  deleteProspect: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .delete(`/api/v1/prospects/${data.id}`)
      .then(response => {
        const title = `Prospect deleted`;
        const message = `Success! <b>${data.prospect_name}</b> has been deleted.`;
        dispatch("showToast", { title, message, type: "success" });
        // re-fetch prospect stages
        return { success: true };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to delete prospect.";
        dispatch("showToast", { message, type: "error" });
        return { success: false };
      });
  },
  //
  createInstructionComment: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .post("/api/v1/comments", { comment: data.comment })
      .then(async response => {
        const input = { id: data.prospect_stage_id };
        await dispatch("getProspectStage", input);
        const title = `New comment added`;
        const message = `Success! New comment has been added.`;
        dispatch("showToast", { title, message, type: "success" });
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to create comment.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  updateInstructionComment: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .patch(`/api/v1/comments/${data.id}`, { comment: data.comment })
      .then(async response => {
        const input = { id: data.prospect_stage_id };
        await dispatch("getProspectStage", input);
        const title = `Comment updated`;
        const message = `Success! The comment has been updated.`;
        dispatch("showToast", { title, message, type: "success" });
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to update comment.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  deleteInstructionComment: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .delete(`/api/v1/comments/${data.id}`)
      .then(async response => {
        const input = { id: data.prospect_stage_id };
        await dispatch("getProspectStage", input);
        const title = `Comment deleted`;
        const message = `Success! The comment has been deleted.`;
        dispatch("showToast", { title, message, type: "success" });
        return { success: true };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to delete comment.";
        dispatch("showToast", { message, type: "error" });
        return { success: false };
      });
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/sales-pipeline.store.js